import React from 'react';
import {Link } from "react-router-dom"
import logo from "../images/logo.svg";
import { useContext } from 'react';
import { appContext} from '../App';

function Navbar() {

  const {navToggle, setNavToggle} = useContext(appContext)
  return (
    <div className='navbar-container'>

        <div className="navbar">
            <Link onClick={()=>setNavToggle(false)} to="/" className="logo">
                <img src={logo} alt="" />
            </Link>
            {navToggle? <Link to='/' 
                        className='go-back'
                        onClick={()=>setNavToggle(false)} 
                        >Go Back</Link> :""
                        // <Link to="/"><button className="button">Start</button></Link> 
            }
        </div>

    </div>
  )
}

export default Navbar